import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import StateContext from "../../contexts/StateContext";
import FormLicencesGenerate from "../forms/FormLicencesGenerate";

/**
 * props can include mode "testgroups"
 */
function GenerateLicences(props) {
  const appState = useContext(StateContext);
  const history = useHistory();

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const texts = {
    default: {
      heading: "Neue Testgruppe anlegen",
      desc: "In diesem Bereich können Sie eigene Testgruppen anlegen und Lizenzen generieren."
    },
    lcclient: {
      heading: "Lizenzen versenden",
      desc: "In diesem Bereich können Sie Lizenzen generieren und an Ihre Institutionen versenden."
    }
  };

  // let testgroups = props.mode && props.mode === "testgroups";
  // const group = appState.user.navType === 'institution-admin' ? 'Testgruppen' : 'Institutionen';
  const group = appState.user.navType === "lizensierender-mandant" ? "lcclient" : "default";
  return (
    <main className="generateLicences">
      <h1 className="title">{texts[group].heading}</h1>
      <p className="info">{texts[group].desc}</p>
      <FormLicencesGenerate
        usertype={appState.user.navType}
        onCancel={e => {
          history.push("/");
        }}
      />
    </main>
  );
}
export default GenerateLicences;
